
const DEV_ENDPOINT = {
    INTEREST_FORM: '/api/v1/enquiry-form',
    PROVINCE_LIST: '/assets/DropdownContent/Province.json',
    PROGRAMME_RECORDS: '/assets/DropdownContent/ProgrammeRecords.json',
    NEWS_AND_EVENT: '/assets/DropdownContent/NewsArticle.json',
}

export default (DEV_ENDPOINT);
